export const mutedText = "text-xs text-black60";
export const paratext = "text-sm text-black80";
